import { formatDustCardNumber } from "@/helpers/cardNumbers";
import type { DustCard } from "./dustCard";

export default {
  skinnyResponseAdapter,
};

async function skinnyResponseAdapter(response: { data: DustCard }) {
  response.data._authRequestFields = ["id"];
  response.data.number = formatDustCardNumber(response.data.number);
  return response.data;
}
